<template>
    <NotificationTile @click="tileClicked()" :isNotificationRead="isNotificationRead">

        <template v-slot:icon>
            <TileIcon :imageName="image" :size="50" padding="8px"></TileIcon>
        </template>

        <template v-slot:title>{{ notification.body.name }}</template>
        <template v-slot:description>{{ formatTime(notification.createdAt) }}</template>

        <template v-slot:coins>
            {{ notification.body.coinsAmount }}
        </template>

    </NotificationTile>
</template>



<script lang="ts">

import { useRouter } from 'vue-router';
import { formatDistanceToNow } from 'date-fns';
import TileIcon from '@/components/Common/Tile-Icon.vue';
import { defineComponent, PropType, computed } from 'vue';
import { InHouseTaskMapping } from "@/constants/InHouseTaskMapping";
import NotificationTile from '@/components/Tiles/Notification/NotificationTile.vue';
import InHouseTaskNotification from '@/interfaces/Notifications/InHouseTaskNotification';

export default defineComponent({
    name: 'InhouseTaskNotificationTile',
    components: {
        TileIcon,
        NotificationTile,
    },
    props: {
        notification: {
            type: Object as PropType<InHouseTaskNotification>,
            required: true,
        },
    },
    setup(props) {

        const router = useRouter();

        const image = InHouseTaskMapping[props.notification.body.name]["image"];

        const isNotificationRead = computed(() => {
            return props.notification.readAt != null;
        });

        const tileClicked = () => {
            router.push('/myearning');
        }

        const formatTime = (time: number) => {
            return formatDistanceToNow(time * 1000) + ' ago';
        }

        return {
            image,
            formatTime,
            tileClicked,
            isNotificationRead,
        };
    },
});
</script>
